import React from 'react';
import { LinkModel } from '../../Types/LinkModel';
import { EditorStringModel } from '../../Types/EditorString';
import EditorString from '../../Components/EditorString/EditorString';
import { translate } from '../../Services/translation';

interface LinkBlockProps {
  links: [
    {
      thumbnailUrl?: string;
      link: LinkModel;
      description: EditorStringModel;
    }
  ];
  link?: LinkModel;
  title?: string;
}

const LinkBlock = ({ links, title, link }: LinkBlockProps) => {
  return (
    <div className="container flex flex-col gap-4">
      <div className="flex items-center justify-between">
        {title && <h2 className="uppercase">{title}</h2>}
        <a href={link?.href} className="py-2 text-xl underline">
          {link?.text}
        </a>
      </div>
      <ul className="flex flex-col gap-6 md:grid md:grid-cols-2 lg:grid-cols-4">
        {links.map((item, idx) => (
          <li className="flex flex-col gap-4" key={'link-' + idx}>
            {item?.thumbnailUrl && (
              <a href={item?.link?.href}>
                <img
                  className="aspect-[4/3] object-cover"
                  src={item?.thumbnailUrl}
                  alt={item?.link?.text}
                />
              </a>
            )}
            <div className="flex flex-col gap-2">
              <a href={item?.link?.href}>
                <h4 className="uppercase">{item?.link?.text}</h4>
              </a>
              <EditorString
                value={item?.description?.value}
                className="text-lg"
              />
            </div>
            <a className="texc-lg underline" href={item?.link?.href}>
              {translate('general.read-more')}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LinkBlock;
